<script setup lang="ts">
import {statusDotClasses, StatusDotState} from "@/core/components/ui/badge/statusDot";

withDefaults(defineProps<{
    state?: StatusDotState;
    /** Tailwind size classes, e.g. `h-2 w-2`. */
    size?: string;
}>(), {
    state: 'unknown',
    size: 'h-2 w-2',
});
</script>

<template>
  <span class="inline-block shrink-0 rounded-full align-middle" :class="[size, statusDotClasses[state]]" />
</template>
